module.exports = __webpack_public_path__ + "img/animals_05_V.cbd96b33.webp";